export default __webpack_public_path__ + "static/media/LAS0880.34I-39653_-23553_0.2eaf8fe1.jpg";